import React, { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function ProjectAudit({ projectId, workspaceId }) {
    const [logs, setLogs] = useState([]);
    useEffect(() => {
        if (!workspaceId) return;
        (async () => {
            // Audit logs may not always carry entity_id filter; fetch latest 100 on workspace and let the user filter mentally
            const { data } = await supabase
                .from('audit_logs').select('*')
                .eq('workspace_id', workspaceId)
                .order('created_at', { ascending: false }).limit(100);
            setLogs(data || []);
        })();
    }, [workspaceId, projectId]);

    return (
        <div className="card-soft overflow-hidden">
            <table className="w-full">
                <thead className="bg-surface-muted text-left text-xs uppercase tracking-wider text-muted-foreground">
                    <tr><th className="px-6 py-3">Action</th><th className="px-6 py-3">Objet</th><th className="px-6 py-3">Date</th></tr>
                </thead>
                <tbody className="divide-y divide-border">
                    {logs.length === 0 && <tr><td colSpan={3} className="px-6 py-10 text-center text-foreground/60">Aucune activité.</td></tr>}
                    {logs.map((l) => (
                        <tr key={l.id}>
                            <td className="px-6 py-3 font-mono text-xs">{l.action}</td>
                            <td className="px-6 py-3 text-foreground/80">{l.entity_type || '—'}</td>
                            <td className="px-6 py-3 text-sm">{new Date(l.created_at).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
